<template>
	<div class="modal-wrapper">
		<div class="warning-container">
			<div class="warning-modal-title">
				{{ $tc('modals.wizardWarning.title') }}
			</div>
			<div class="warning-modal-body">
				{{ $tc('modals.wizardWarning.mainText') }}
			</div>
			<button class="warning-btn button-light-blue" @click="onConfirm">
				{{ $tc('modals.wizardWarning.yesButtonText') }}
			</button>
			<button class="warning-btn button-light-blue" @click="onClose">
				{{ $tc('modals.wizardWarning.noButtonText') }}
			</button>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardWarning',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>
